import {createContext, useContext, useState, useEffect, useMemo} from 'react';
import {AnchorProvider, Program, setProvider, web3} from "@coral-xyz/anchor";
import type {Revshare} from "../components/SolanaPools/anchor-idl/idl.ts";
import type {Provider as AppKitProvider} from "@reown/appkit-adapter-solana/react";
import Idl from "../components/SolanaPools/anchor-idl/idl.json";
import { useAppKitProvider} from "@reown/appkit/react";
import {AnyTransaction} from "@reown/appkit-adapter-solana";
import {AnchorWallet} from "@solana/wallet-adapter-react";


type ProgramContextType = {
  program?: Program<Revshare>;
};

const ProgramContext = createContext<ProgramContextType | undefined>(undefined);

type ProgramProviderProps = {
  children: React.ReactNode;
};

export const ProgramProvider: React.FC<ProgramProviderProps> = ({children}:ProgramProviderProps) => {
  const {walletProvider} = useAppKitProvider<AppKitProvider>("solana");

  const [program, setProgram] = useState<Program<Revshare> | undefined>(undefined);




  useEffect(() => {
    const initProgram = async () => {

      if (
        walletProvider &&
        walletProvider.publicKey &&
        walletProvider.signTransaction &&
        walletProvider.signAllTransactions
      ) {
        const achorWallet = {
          publicKey: walletProvider.publicKey,
          signTransaction: walletProvider.signTransaction<AnyTransaction>,
          signAllTransactions: walletProvider.signAllTransactions<AnyTransaction[]>
        } as AnchorWallet;
        const p = new AnchorProvider(

          new web3.Connection(
            "https://api.zenexhub.com/v4/rpc",
            "confirmed"
          ),
          achorWallet
        )

        setProvider(p)

        const _program = new Program<Revshare>(Idl as Revshare,);
        // console.log(await _program.account.zenexPoolStateV2.all())
        setProgram(_program);
      }
    };

    initProgram().catch(console.error);
  }, [walletProvider?.publicKey?.toBase58()]);



  return (
    <ProgramContext.Provider value={{program}}>
      {children}
    </ProgramContext.Provider>
  );
};

export const useProgram = () => {
  const ctx = useContext(ProgramContext);
  if (!ctx) {
    throw new Error("useProgram must be used within a ProgramProvider");
  }
  return ctx;
};